import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AlertBox from './AlertBox';

export default class TimezoneChecker extends Component {
  static propTypes = {
    useTimezone: PropTypes.string,
    userTimezoneUrl: PropTypes.string,
  }

  constructor(props) {
    super(props);
    this.state = { open: (localStorage.getItem('TimezoneChecker.dismissed') !== 'yes') };
  }

  setBrowser = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    $.ajax({
      type: 'PATCH',
      url: this.props.userTimezoneUrl,
      data: {
        user: {
          timezone: moment.tz.guess(),
        },
      },
      success: () => {
        this.setState({ open: false });
        window.location.reload();
      },
    });
  }

  dismiss = (e) => {
    e.stopPropagation();
    e.preventDefault();
    localStorage.setItem('TimezoneChecker.dismissed', 'yes');
    this.setState({ open: false });
  }

  componentDidMount() {
    if (!this.props.useTimezone) {
      this.setBrowser();
    }
  }

  render() {
    const preference = this.props.useTimezone;
    const browser = moment.tz.guess();
    const browserDisplay = browser.split('/')[browser.split('/').length - 1].replace('_', ' ');
    let message = null;
    if (preference) {
      // user preference found. check if it differs from browser
      if (preference !== browser) {
        const preferenceDisplay = preference.split('/')[preference.split('/').length - 1].replace('_', ' ');
        message = (
          <div>
            It seems your time zone changed from <strong>{preferenceDisplay}</strong> to <strong>{browserDisplay}</strong>
            . <a onClick={this.setBrowser}>Change it</a> or <a onClick={this.dismiss}>dismiss</a>.
          </div>
        );
      }
      // otherwise, everything is fine, we don't render anything
    }
    if (this.state.open && message) {
      return (
        <AlertBox message={message} fixed={false} type="warning" dismissable={false} />
      );
    }
    return <div />;
  }
}
